import React from 'react';
import { Icon } from '@pwc/pwc-deals-ui';
import classnames from 'classnames';
import {
  sortAscending,
  sortDirShape,
} from '../../common/components/proptypes/commonProptypes';
import './SortChevron.scss';

const SortChevron = ({ currentSortDir }) => {
  const chevronClassNames = classnames('sort-chevron-desc', {
    asc: currentSortDir === sortAscending,
  });
  return (
    <span className={chevronClassNames}>
      <Icon name="desc" width="10" className="fill icon-orange" />
    </span>
  );
};

SortChevron.propTypes = {
  currentSortDir: sortDirShape.isRequired,
};

export default SortChevron;
